import * as React from 'react';
import { ServiceSummary } from '../../../features/service-summary';
const BaggageDelivery = ({ onServiceDelete }) => {
    return (React.createElement(ServiceSummary, { serviceType: "BaggageDelivery", onDelete: onServiceDelete }, content => React.createElement(React.Fragment, null, content)));
};
export default BaggageDelivery;
